module.exports = __webpack_public_path__ + "img/4.ccfdd8e1.jpeg";